import React from 'react';
import PropTypes from 'prop-types';

class Debounce extends React.Component {
  static propTypes = {
    children: PropTypes.node,
    wait: PropTypes.number
  };

  static propTypesMeta = 'exclude';

  static defaultProps = {
    wait: 0
  };

  state = {
    children: this.props.children
  };

  timer = null;

  componentWillUnmount() {
    clearTimeout(this.timer);
  }

  componentDidUpdate(prevProps) {
    if (prevProps !== this.props) {
      clearTimeout(this.timer);
      this.timer = setTimeout(() => {
        this.setState({ children: this.props.children });
      }, this.props.wait);
    }
  }

  render() {
    return this.state.children;
  }
}

export default Debounce;
